import React from 'react';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { Loader } from 'semantic-ui-react';
import { inject, observer } from 'mobx-react';

import ImageEditor from '../../components/ImageEditor';

import { __ } from '../../i18n';

const createCover = organizationId => `mutation createCover {
  createCover(input: { organizationId: ${organizationId} }) {
    clientMutationId
  }
}`;

@graphql(gql`query OrganizationCoverQuery ($id: ID!) {
  node(id: $id) @connection(key: "Organization", filter: ["id"]) {
    ... on Organization {
      id: dbId
      cover {
        id: dbId
        original : uri(size: "w1240")
      }
    }
  }
}`, {
  options: ownProps => ({
    variables: {
      id: ownProps.params.organization_id
    }
  })
})
@graphql(gql`mutation deleteCover($deleteCoverMutation: DeleteCoverInput!) {
  deleteCover(input: $deleteCoverMutation) {
    clientMutationId
  }
}`, {
  name: 'deleteCover',
  options: {
    refetchQueries: ['EntityNodeQuery', 'OrganizationNodeQuery', 'AppQuery']
  }
})

@inject('store') @observer
export default class OrganizationCover extends React.Component {
  backAndRefresh = () => {
    const { store, router } = this.props;

    this.props.data.refetch();

    if (store.history.length > 1) {
      router.goBack();
    } else {
      const link = store.previous.params.entity_id ? `/entities/${store.previous.params.entity_id}/messages` :
        (store.previous.params.organization_id ? `/organizations/${store.previous.params.organization_id}/messages` : '/');
      router.push(link);
    }
  }

  render() {
    const { data, deleteCover } = this.props;

    if ((data.loading && !data.node) || !data.node) return <Loader active />;

    const { id, cover } = data.node;

    return (
      <ImageEditor
        id="OrganizationCover"
        header={__('Edit Cover')}
        backAndRefresh={() => this.backAndRefresh()}
        submitRequest={createCover(id)}
        onSubmit={this.backAndRefresh}
        submitTarget={'cover'}
        deleteRequest={deleteCover}
        onDelete={this.backAndRefresh}
        deleteParams={{ deleteCoverMutation: { organizationId: id } }}
        hasPicture={cover && cover.original}
        width={1500}
        height={500}
      />
    );
  }
}
